<template>
  <v-card max-width="800" style="height: 100%" class="mx-auto">
    <v-app-bar dark style="color: #bc4749" color="#ffffff">
      <v-btn icon>
        <v-icon style="color: #bc4749">mdi-presentation</v-icon>
      </v-btn>

      <v-toolbar-title style="text-transform: uppercase"
        ><b>{{ vName }}</b></v-toolbar-title
      >

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-card color="#386641" style="min-height: 15rem" dark>
            <v-card-title class="headline"> <b>Descripción</b> </v-card-title>
            <div class="simpleText">{{ vDescription }}</div>
            
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
export default {
  props: {
    vName: String,
    vDescription: String,
  },
};
</script>
<style scoped>
.simpleText {
  text-align: left;
  padding: 0.5rem 2rem;
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/stream_video_components/description.vue